<template>
    <div class="icon-wrapper" :class="{'disabled': disabled}" style="width: 100%; height: 100%; min-height: 48px;">
        <div
            class="icon-wrapper__content" style="width: 100%; height: 100%;"
        >
            <slot></slot>
        </div>
        <div
            v-if="!disabled"
            class="icon-wrapper__icon"
            @click.stop.prevent="$emit('click:icon')">
            <v-icon>
                {{ icon || 'mdi-pencil' }}
            </v-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditIconContainer",
        props: {
            icon: {
                type: String,
                default: undefined,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        }
    }
</script>

<style scoped>
    .icon-wrapper {
        display: flex;
        flex-direction: row;
        height: 100%;
        width: 100%;
        justify-content: stretch;
        align-items: center;
        padding: 1px;
    }

    .icon-wrapper__content {
        flex-grow: 1;
    }

    .icon-wrapper__icon {
        display: flex;
        flex-grow: 0;
        justify-content: center;
        align-items: center;
        background-color: #aaa;
        visibility: hidden;
    }

    .icon-wrapper__icon:hover {
        background-color: rgba(12, 162, 253, 0.7);
        cursor: pointer;
    }

    td:hover .icon-wrapper__icon {
        visibility: visible;
    }

    td:hover .icon-wrapper:not(.disabled) {
        border: 1px dashed #ddd;
        padding: 0;
    }
</style>